/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveBlCrSubMarca } from "../../services/BlCrSubMarcaService";
import { getBlCrMarcas } from "../../services/BlCrMarcaService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  descripcion: "",
  idBlCrMarca: null,
  observaciones: "",
};

const nameItemText = "Submarca de Block/Cristal";
const itemGender = "F";
//
// ########################################################################### 
//
const BlCrSubMarcaDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [lcMarcas, setLcMarcas] = useState([]);
  const [valueACBlCrMarcas, setValueACBlCrMarcas] = useState(actionCrud === "new" ? null : { id: itemCrud.blCrMarca.id, label: itemCrud.blCrMarca.label });
  const [inputValueACBlCrMarcas, setInputValueACBlCrMarcas] = useState("");
  //
  // ################################################################################
  //
  useEffect(() => {
    loadBlCrMarcas();

    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (itemCrudLocal.idBlCrMarca === null) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar la Marca del Block/Cristal",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Submarca del Block/Cristal",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      id_bl_cr_marca: valueACBlCrMarcas.id,
      descripcion: itemCrudLocal.descripcion,
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveBlCrSubMarca(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const loadBlCrMarcas = async () => {
    setIsDoingSomething(true);
    const response = await getBlCrMarcas();
    setIsDoingSomething(false);

    if (response.ok) {

      let _response = response.data.data;
      let _lcMarcas = [];
      _response.forEach((item) => {
        _lcMarcas.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcMarcas(_lcMarcas);
    } else {
      setLcMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="sm"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Autocomplete
                id="BlCrMarcas"
                sx={{ width: "100%" }}
                size="small"
                value={valueACBlCrMarcas}
                onChange={(event, newValue) => {
                  setValueACBlCrMarcas(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrMarca: newValue.id,
                  });
                }}
                inputValue={inputValueACBlCrMarcas}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrMarcas(newInputValue);
                }}
                options={lcMarcas}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Marcas de Block/Cristal" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"}
                disableClearable={true}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Submarca de Block/Cristal"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion ? itemCrudLocal.descripcion : ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default BlCrSubMarcaDialog;
